import React from "react";
import { Alert, Box, Chip, Typography } from "@mui/material";

function qualityChipColor(quality) {
  if (quality === "excellent") return "success";
  if (quality === "good") return "info";
  return "warning";
}

function qualityLabel(quality, t) {
  if (quality === "excellent") return t("agentsListPage.pdfTemplateQualityExcellent");
  if (quality === "good") return t("agentsListPage.pdfTemplateQualityGood");
  return t("agentsListPage.pdfTemplateQualityPoor");
}

/**
 * Painel de qualidade do modelo PDF após análise (proposta/contrato).
 */
export default function PdfTemplateQualityPanel({ cfg, t }) {
  if (!cfg || !cfg.analyzed_at) return null;

  const quality = cfg.template_quality || "poor";
  const positioned = Number(cfg.positioned_count) || 0;
  const fillable = Number(cfg.fillable_field_count) || positioned;
  const ratio = cfg.fill_coverage_ratio != null ? Math.round(cfg.fill_coverage_ratio * 100) : null;
  const missingKeys = Array.isArray(cfg.missing_position_keys) ? cfg.missing_position_keys : [];
  const rejectedKeys = Array.isArray(cfg.rejected_field_keys) ? cfg.rejected_field_keys : [];
  const modeHint = cfg.generation_mode_hint;

  const coverageText =
    ratio != null
      ? t("agentsListPage.pdfTemplateCoverageDetail", {
          positioned,
          total: fillable || positioned,
          percent: ratio,
        })
      : t("agentsListPage.pdfTemplateCoverageSimple", { positioned });

  const severity = quality === "poor" ? "warning" : quality === "good" ? "info" : "success";

  return (
    <Box sx={{ mt: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1, flexWrap: "wrap" }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
          {t("agentsListPage.pdfTemplateQualityTitle")}
        </Typography>
        <Chip
          size="small"
          label={qualityLabel(quality, t)}
          color={qualityChipColor(quality)}
          variant="outlined"
        />
        {modeHint === "template_fill" && (
          <Chip size="small" label={t("agentsListPage.pdfTemplateModeFill")} color="success" />
        )}
        {modeHint === "ai_fallback_likely" && (
          <Chip size="small" label={t("agentsListPage.pdfTemplateModeAiFallback")} color="warning" variant="outlined" />
        )}
      </Box>

      <Alert severity={severity} sx={{ py: 0.75 }}>
        <Typography variant="body2">{coverageText}</Typography>
        {quality === "poor" && (
          <Typography variant="body2" sx={{ mt: 0.5 }}>
            {t("agentsListPage.pdfTemplateQualityPoorHint")}
          </Typography>
        )}
        {missingKeys.length > 0 && (
          <Typography variant="caption" display="block" sx={{ mt: 0.75 }}>
            {t("agentsListPage.pdfTemplateMissingPositions", { keys: missingKeys.join(", ") })}
          </Typography>
        )}
        {rejectedKeys.length > 0 && (
          <Typography variant="caption" display="block" sx={{ mt: 0.5 }}>
            {t("agentsListPage.pdfTemplateRejectedFields", { keys: rejectedKeys.join(", ") })}
          </Typography>
        )}
      </Alert>
    </Box>
  );
}
